import React, { useEffect, useMemo, useState } from "react";
import { usePlayer, useStage } from "@empirica/core/player/classic/react";

const culculateRemainingTime = (initialPredictionAt) => {
  const elapsed = Math.floor((Date.now() - new Date(initialPredictionAt)) / 1000);
  return elapsed;
};


export function AIDiscuss() {
  const player = usePlayer();
  const stage = useStage();

  const hasConcluded = stage.get("aiGroupConcluded") === true;
  const [waitTime, setWaitTime] = useState(culculateRemainingTime(player.get("aiStartDiscussAt") || Date.now()));

  useEffect(() => {
    const timer = setInterval(() => {
      let initialPredictionAt = player.get("aiStartDiscussAt");
      if (!initialPredictionAt) {
        player.set("aiStartDiscussAt", Date.now());
      }
      initialPredictionAt = player.get("aiStartDiscussAt");
      const remaining = culculateRemainingTime(initialPredictionAt);

      setWaitTime(remaining);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (hasConcluded && !player.stage.get("submit")) {
      player.stage.set("submittedAt", Date.now());
      player.stage.set("submit", true);
    }
  }, [hasConcluded, player]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6">AI Assistants Are Discussing</h2>
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center gap-4 mb-4">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full">
            <svg className="w-6 h-6 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
          <div className="text-sm text-gray-600">
            <div className="font-medium text-gray-900">Please wait while AI assistants discuss your group's predictions</div>
            <div>We’ll proceed to a concise summary as soon as the discussion ends.</div>
            <div className="mt-1 text-xs">Estimated duration: about 4–6 minutes</div>
            <div className="mt-1 text-xs">Elapsed: <span className="font-mono">{formatTime(waitTime)}</span></div>
          </div>
        </div>
        {hasConcluded && (
          <div className="mt-4 p-3 rounded bg-green-50 border border-green-200 text-green-800 text-sm">
            Discussion complete—moving to the summary.
          </div>
        )}
      </div>
    </div>
  );
}


